import { NgModule } from '@angular/core';
import { ReversePipe, TimeGreetingPipe, StringFilterByPipe, UtcToLocalPipe, filter } from './filter';

@NgModule({
  imports: [],
  declarations: [
    filter,
    ReversePipe,
    TimeGreetingPipe,
    StringFilterByPipe,
    UtcToLocalPipe,
  ],
  exports: [
    filter,
    ReversePipe,
    TimeGreetingPipe,
    StringFilterByPipe,
    UtcToLocalPipe,
  ]
})

export class PipeModule { }
